import {z} from '@hono/zod-openapi';

export const imageGenerationStyleSchema = z.enum(['badge', 'illustration']);
export type ImageGenerationStyle = z.infer<typeof imageGenerationStyleSchema>;
